import { Col, FormCheck, FormControl, FormLabel, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";

export default function Fire() {
	const [firePoints, setFirePoints] = useState(0);
	const [combatStands, setCombatStands] = useState(0);
	const [isUnderSail, setIsUnderSail] = useState(false);
	const [fireAttackResult, setFireAttackResult] = useState(-1);

	const resultExplinations: string[] = [
		"Fire has been extinguished",
		"Minor Fire: Half the present Fire Points are used next turn (rounded down); 50% of the personnel (controlling player's choice) on the vessel's deck must be used to fight fire; the other half is not effected.",
		"Substantial Fire: All prsent Fire Points are used next turn; 50% of the personnel (controlling player's choice) on the vessel's deck must be used to fight fire. Missile fire from vessel is done at -1",
		"Major Fire: All Fire Points are used next turn: everyone on the ship's deck must be used to fight the fire. If ship is in Close Combat it will surrender.",
		"Ship is Engulfed in Flames: All personnel have one turn to abandon the ship after which the vessel will become a Flaming Wreck. Any vessel colliding with or grappled to a Flaming Wreck will be subjected to 1d10 of Fire Points."
	];

	const table: number[][] = [
		[1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
		[1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
		[1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
		[1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
		[1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
		[2, 2, 1, 1, 0, 0, 0, 0, 0, 0],
		[2, 2, 1, 1, 0, 0, 0, 0, 0, 0],
		[2, 2, 1, 1, 0, 0, 0, 0, 0, 0],
		[2, 2, 1, 1, 0, 0, 0, 0, 0, 0],
		[2, 2, 1, 1, 0, 0, 0, 0, 0, 0],
		[3, 3, 2, 2, 1, 1, 0, 0, 0, 0],
		[3, 3, 2, 2, 1, 1, 0, 0, 0, 0],
		[3, 3, 2, 2, 1, 1, 0, 0, 0, 0],
		[3, 3, 2, 2, 1, 1, 0, 0, 0, 0],
		[3, 3, 2, 2, 1, 1, 0, 0, 0, 0],
		[4, 4, 3, 3, 3, 3, 2, 2, 1, 1],
		[4, 4, 3, 3, 3, 3, 2, 2, 1, 1],
		[4, 4, 3, 3, 3, 3, 2, 2, 1, 1],
		[4, 4, 3, 3, 3, 3, 2, 2, 1, 1],
		[4, 4, 3, 3, 3, 3, 2, 2, 1, 1],
		[4, 4, 4, 4, 3, 3, 2, 2, 1, 1],
	];

	function rollForFireAttackResults() {
		const combatStandModifier: number = combatStands < 3 ? 0 : combatStands < 8 ? 1 : 2;
		const tableRow: number[] = firePoints <= 20 ? table[firePoints - 1] : table[20];

		const modifiedDieRoll: number = RollDice(1)[0] + combatStandModifier - (isUnderSail ? 1 : 0);

		setFireAttackResult(tableRow[modifiedDieRoll]);
	}

	return (
		<>
			<Row>
				<Col>
					<h1>Fire Attack Table</h1>
				</Col>
			</Row>
			{fireAttackResult === -1 ? null : (
				<Row className={fireAttackResult === 4 ? "p-3 text-center bg-danger" : "p-3 text-center"}>
					<Col>
						<h4 className={fireAttackResult === 0 ? "text-success" : fireAttackResult === 4 ? "text-light" : "text-danger"}>{resultExplinations[fireAttackResult]}</h4>
					</Col>
				</Row>
			)}
			<Row className="my-3">
				<Col>
					<FormLabel htmlFor="fire-points">Fire Points</FormLabel>
					<FormControl id="fire-points" type="number" min={1} value={firePoints} onChange={(e) => setFirePoints(parseInt(e.target.value))} />
				</Col>
				<Col>
					<FormLabel htmlFor="combat-stands">Combat Stands Fighting Fire</FormLabel>
					<FormControl id="combat-stands" type="number" min="0" value={combatStands} onChange={(e) => setCombatStands(parseInt(e.target.value))} />
				</Col>
			</Row>
			<Row>
				<Col>
					<FormCheck type="checkbox" label="Vessel fighting fire is using Sail Power" checked={isUnderSail} onChange={(e) => setIsUnderSail(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col xs={12}>
					<button className="btn btn-primary" onClick={() => rollForFireAttackResults()}>Roll for Fire Attacks</button>
				</Col>
				<Col className="mt-3">
					<button className="btn btn-danger" onClick={() => setFireAttackResult(-1)}>Clear Results</button>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<p><em><b>Note:</b> In cases where players must commit 50% of the ship&apos;s Combat Stands to fighting a fire, these Combat Stands may not participate in Missile Attack or Close Combat phases. Only Combat Stands on the ship&apos;s deck may fight fires.</em></p>
				</Col>
			</Row>
		</>
	);
}